import axiosInstance from './api'
import { mapCounselorThreadMessage } from './mapCounselorThreadMessage'

export { mapCounselorThreadMessage } from './mapCounselorThreadMessage'

/**
 * Fetch list of students with their last message for the current counselor.
 * Backend: GET /counseling/counselor/messages/students
 */
export const fetchUsers = async () => {
	try {
		const response = await axiosInstance.get(
			'/counseling/counselor/messages/students',
		)

		const raw = response.data?.students || response.data || []

		return raw.map((item, index) => {
			const studentId = String(
				item.student_id ?? item.studentId ?? item.id ?? index,
			)
			const hasConversation = item.has_messages !== false

			return {
				id: studentId,
				studentId,
				name: item.student_name || item.name || 'Unknown',
				email: item.student_email || item.email || '',
				lastMessage: item.last_message || item.lastMessage || '',
				lastActiveAt: item.last_message_at || item.lastActiveAt || null,
				unreadCount: item.unread_count ?? item.unreadCount ?? 0,
				hasConversation,
			}
		})
	} catch (error) {
		console.error('Error fetching counselor message students:', error)
		throw error
	}
}

/**
 * Fetch messages between counselor and a specific student.
 * Backend: GET /counseling/counselor/messages/<student_id>
 */
export const fetchMessages = async (
	studentId,
	{ page = 1, limit = 50 } = {},
) => {
	if (!studentId) return []

	try {
		const encodedId = encodeURIComponent(String(studentId))
		const response = await axiosInstance.get(
			`/counseling/counselor/messages/${encodedId}`,
			{
				params: { page, limit },
			},
		)

		const raw = response.data?.messages || response.data || []

		return raw.map(mapCounselorThreadMessage)
	} catch (error) {
		console.error('Error fetching counselor messages:', error)
		throw error
	}
}

/**
 * Send message from counselor to a specific student.
 * Backend: POST /counseling/counselor/messages
 */
export const sendMessage = async (studentId, message) => {
	const normalizedId = String(studentId || '').trim()
	const text = String(message || '').trim()

	if (!normalizedId || !text) {
		return { success: false }
	}

	try {
		const response = await axiosInstance.post(
			'/counseling/counselor/messages',
			{
				message: text,
				student_ids: [normalizedId],
			},
		)

		return { success: true, data: response.data }
	} catch (error) {
		console.error('Error sending counselor message:', error)
		return { success: false, error }
	}
}

/**
 * Mark a single message as read by counselor.
 * Backend: PUT /counseling/counselor/messages/<message_id>/read
 */
export const markMessageAsRead = async messageId => {
	const id = String(messageId || '').trim()
	if (!id) return

	try {
		await axiosInstance.put(`/counseling/counselor/messages/${id}/read`)
	} catch (error) {
		console.error('Error marking message as read:', error)
	}
}
